module.exports = __webpack_public_path__ + "img/HC2013-135.b7502a17.jpg";